import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router/index'
import piniaPersistedState from 'pinia-plugin-persistedstate';
import { useRouterStateStore } from './stores/routerState';

const app = createApp(App)

// Use Pinia store with persisted state plugin
const pinia = createPinia();
pinia.use(piniaPersistedState);
app.use(pinia);

app.use(router)  

// Wait for the router to be fully initialized before accessing the route state
router.isReady().then(() => {
    const routerStateStore = useRouterStateStore();
    const lastRoute = routerStateStore.getRoute;
    // Ensure we only push if we're not already on the last route
    if (lastRoute && lastRoute !== router.currentRoute.value.fullPath && lastRoute !== '/') {
        router.push(lastRoute);
    }
  });

app.mount('#app')
